module.exports = __webpack_public_path__ + "static/media/yaw_misalign_wind.9d557318.svg";